import React from 'react';
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="py-[72px] bg-[#030509] border-t border-[#242832]">
      <div className="w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto text-center">
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-[clamp(34px,3.8vw,54px)] font-semibold text-white leading-[1.08] tracking-[-0.035em] mb-[24px]">
            Move with clarity—not guesswork.
          </h2>
          <p className="text-[clamp(17px,1.3vw,20px)] text-[#A7ADB8] leading-[1.65] font-normal mb-[32px]">
            Know what is happening, understand why it matters and give your team a clearer direction for the next campaign, message or market decision.
          </p>
          
          <Link 
            to="/request-review" 
            className="inline-block bg-white text-[#030509] px-[40px] py-[24px] rounded-xl text-[13px] font-bold uppercase tracking-[0.1em] hover:bg-gray-200 transition-all"
          >
            Request Your Intelligence Review
          </Link>
        </div>
      </div>
    </section>
  );
}